query GetChatOverlayDataById($slug: String, $chatId: ID!) {
  chatOverlay: StreamToolsGetChatOverlayDataById(slug: $slug, chatId: $chatId) {
    channels {
      channelLogin
      broadcasterUserId
      profileImageUrl
    }
    globalBadges {
      set
      versions {
        version
        url
      }
    }
    channelBadges {
      broadcasterUserId
      sets {
        set
        versions {
          version
          url
        }
      }
    }
    config {
      chatId
      name
      showTextShadow
      textShadow
      showBadges
      showChannelPills
      usernameFontSize
      usernameLineHeight
      messageFontSize
      messageLineHeight
      messageFontWeight
      usernameFontWeight
      imageScale
      messageColor
      blockedWords
      fontFamily
      youtubeSourceEnabled
      youtubeChatChannels
      chatDelayMs
      width
      height
      show7tvEmotes
      showBttvEmotes
      showFfzEmotes
      twitchChatChannels
      showYouTubeProfilePictures
    }
    accountChatChannel
  }
}
